import f3tch from 'f3tch';

import API_URL from '../../constants/url.constant.api';
import profile from '../../profiles/json.profile.api';

const updateUserApi = (user) =>
  f3tch('/users')
    .profile(profile({url: API_URL()}))
    .body(user)
    .patch();

export default updateUserApi;
